// Splide スライダー初期化
//
// ページ内の `.splide` 全てを mount する。
// 既存マークアップ前提:
//   <div class="splide">
//     <div class="splide__track">
//       <ul class="splide__list">
//         <li class="splide__slide">...</li>
//       </ul>
//     </div>
//   </div>
//
// 個別調整はマークアップ側で `data-splide='{...}'` を渡せば JSON.parse してマージする。
//   <div class="splide" data-splide='{"perPage":2,"autoplay":true}'>
export default () => {
  if (typeof Splide === 'undefined') return;

  const defaults = {
    type: 'loop',
    perPage: 'auto',

    gap: '40px',
    perMove: 1,
    arrows: true,
    pagination: false,
    classes: {
      prev  : 'c-arrow _white _prev',
      next  : 'c-arrow _white _next',
    },
    breakpoints: {
      900: { perPage: 1, gap: '20px' },
      // 1200: { perPage: 2, gap: '30px' },
    },
  };

  document.querySelectorAll('.splide').forEach((el) => {
    if (el.dataset.splideInit === '1') return;

    let opts = defaults;
    if (el.dataset.splide) {
      try {
        opts = { ...defaults, ...JSON.parse(el.dataset.splide) };
      } catch (e) {
        console.warn('[slider] invalid data-splide JSON:', e);
      }
    }

    new Splide(el, opts).mount();
    el.dataset.splideInit = '1';
  });
};
